import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BASE_URL } from '@ai-platform/utils';

import { StoreProvider } from './store';
import { AppRoutes } from './pages';
import { ScrollRestoration } from './components/ScrollRestoration';
import { UserProvider, ModalProvider } from './contexts';
import { AppMeta } from './App.meta';

import './styles/global.scss';
import { ExperimentsProvider } from './contexts/ExperimentsContext';
import { PromptsViewedTrackerProvider } from './VisibilityTracker';

export const App: React.FC = () => {
    return (
        <HelmetProvider>
            <AppMeta />
            <BrowserRouter basename={BASE_URL}>
                <ExperimentsProvider>
                    <StoreProvider>
                        <UserProvider>
                            <ModalProvider>
                                <PromptsViewedTrackerProvider>
                                    <ScrollRestoration>
                                        <AppRoutes />
                                    </ScrollRestoration>
                                </PromptsViewedTrackerProvider>
                            </ModalProvider>
                        </UserProvider>
                    </StoreProvider>
                </ExperimentsProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
};
